import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import authAxios from '../../../config/authAxios';
import { avisoCorrecto, avisoError } from '../../components/AvisosMensajes/MensajesSwalf';

const ACCIONES = [
  { value: 'cancela_deuda', label: 'Cancelará deuda' },
  { value: 'activo', label: 'Estará activo' },
  { value: 'justificar_asistencia', label: 'Justificará asistencia' },
  { value: 'participa_clase', label: 'Participará más en clases' },
  { value: 'rendira_evaluacion', label: 'Rendirá evaluación extemporánea' },
  { value: 'otro', label: 'Otro / requiere comentario' },
];

const CANALES = ['WhatsApp', 'Llamada', 'Correo', 'Presencial'];

const FichaGestion = ({ fila, onClose }) => {
  const [historial, setHistorial] = useState([]);
  const [accion, setAccion] = useState('');
  const [comentario, setComentario] = useState('');
  const [canal, setCanal] = useState('');
  const [proximaFecha, setProximaFecha] = useState('');
  const [loading, setLoading] = useState(false);

  const usuario = useSelector(state => state.usuario?.usuario || state.usuario);

  useEffect(() => {
    cargarHistorial();
  }, [fila.id_matricula_proyecto]);

  const cargarHistorial = async () => {
    try {
      const res = await authAxios.get(`/admin/gestion/historial/${fila.id_matricula_proyecto}`);
      setHistorial(res.data?.data || []);
    } catch (e) { }
  };

  const handleGuardar = async () => {
    if (!accion) { avisoError('Selecciona una acción'); return; }
    setLoading(true);
    try {
      await authAxios.post('/admin/gestion/registrar', {
        id_matricula_proyecto: fila.id_matricula_proyecto,
        id_usuario_responsable: usuario?.id_usuario || usuario?.id,
        accion,
        comentario,
        canal,
        proxima_fecha: proximaFecha || null,
      });
      avisoCorrecto('Gestión registrada');
      setAccion(''); setComentario(''); setCanal(''); setProximaFecha('');
      cargarHistorial();
    } catch (e) {
      avisoError('Error al registrar');
    }
    setLoading(false);
  };

  const semColor = fila.color_estado === 'VERDE' ? '#18BB60'
    : fila.color_estado === 'AMBAR' ? '#F39C12'
    : fila.color_estado === 'GRIS' ? '#95A5A6' : '#E12E1C';

  return (
    <div style={{
      position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh',
      background: '#fff', boxShadow: '-4px 0 16px rgba(0,0,0,0.15)',
      zIndex: 9999, overflowY: 'auto', padding: '24px'
    }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Ficha de gestión</h5>
        <button className="btn btn-sm btn-light" onClick={onClose}>✕</button>
      </div>

      {/* Datos del alumno */}
      <div className="card mb-3" style={{ borderLeft: `4px solid ${semColor}` }}>
        <div className="card-body py-2">
          <div className="d-flex align-items-center mb-1">
            <span style={{ background: semColor, color: '#fff', borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: 'bold', marginRight: '8px' }}>
              {fila.color_estado}
            </span>
            <strong>{fila.nombre} {fila.apellido}</strong>
          </div>
          <small className="text-muted">DNI: {fila.dni} | {fila.telefono} | {fila.correo}</small>
        </div>
      </div>

      {/* Estado financiero y académico */}
      <div className="row mb-3" style={{ fontSize: '13px' }}>
        <div className="col-6">
          <div className="card p-2 h-100">
            <div className="text-muted mb-1" style={{ fontSize: '11px' }}>ESTADO FINANCIERO</div>
            <span style={{ color: fila.pago === 'MOROSO' ? '#E12E1C' : '#18BB60', fontWeight: 'bold' }}>
              {fila.pago === 'MOROSO' ? '⚠ Deuda: S/.' + fila.importe_deuda : '✓ Al día'}
            </span>
          </div>
        </div>
        <div className="col-6">
          <div className="card p-2 h-100">
            <div className="text-muted mb-1" style={{ fontSize: '11px' }}>ESTADO ACADÉMICO</div>
            <div>Nota: <strong>{fila.promedio_final}</strong> / Óptima: <strong>{fila.promedio_optimo}</strong></div>
            <div>Asistencia: <strong>{fila.cant_asistidas}/{fila.cant_se_realizada}</strong></div>
            <div>Cumpl.: <strong>{fila.cumplimiento}%</strong></div>
          </div>
        </div>
      </div>

      <div className="mb-3" style={{ fontSize: '13px' }}>
        <span className="text-muted">Pts. eval: </span><strong>{fila.puntos_inedi}</strong>
        &nbsp;|&nbsp;
        <span className="text-muted">Pts. adic: </span><strong>{fila.puntos_adicionales}</strong>
        &nbsp;|&nbsp;
        <span className="text-muted">Total: </span><strong>{fila.total_puntos}</strong>
      </div>

      {/* Ritmo */}
      <div className="mb-3">
        <span style={{
          padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold',
          background: fila.ritmo === 'AL DÍA' ? '#d4edda'
            : fila.ritmo === 'PREVENTIVO' ? '#fff3cd'
            : fila.ritmo === 'RETRASADO' ? '#fde8d8'
            : fila.ritmo === 'CRÍTICO' ? '#f8d7da' : '#e9ecef',
          color: fila.ritmo === 'AL DÍA' ? '#155724'
            : fila.ritmo === 'PREVENTIVO' ? '#856404'
            : fila.ritmo === 'RETRASADO' ? '#d35400'
            : fila.ritmo === 'CRÍTICO' ? '#721c24' : '#6c757d'
        }}>
          Ritmo: {fila.ritmo}
        </span>
      </div>

      <hr />

      {/* Nueva acción */}
      <h6>Registrar gestión</h6>
      <div className="form-group mb-2">
        <label style={{ fontSize: '12px' }}>Acción *</label>
        <select className="form-control form-control-sm" value={accion} onChange={e => setAccion(e.target.value)}>
          <option value="">-- Seleccionar --</option>
          {ACCIONES.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
        </select>
      </div>
      <div className="form-group mb-2">
        <label style={{ fontSize: '12px' }}>Canal</label>
        <select className="form-control form-control-sm" value={canal} onChange={e => setCanal(e.target.value)}>
          <option value="">-- Seleccionar --</option>
          {CANALES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div className="form-group mb-2">
        <label style={{ fontSize: '12px' }}>Comentario</label>
        <textarea className="form-control form-control-sm" rows="2" value={comentario} onChange={e => setComentario(e.target.value)} />
      </div>
      <div className="form-group mb-3">
        <label style={{ fontSize: '12px' }}>Próxima fecha de seguimiento</label>
        <input type="date" className="form-control form-control-sm" value={proximaFecha} onChange={e => setProximaFecha(e.target.value)} />
      </div>
      <button className="btn btn-primary btn-sm w-100 mb-3" onClick={handleGuardar} disabled={loading}>
        {loading ? 'Guardando...' : 'Registrar gestión'}
      </button>

      <hr />

      {/* Historial */}
      <h6>Historial ({historial.length})</h6>
      {historial.length === 0 ? (
        <p className="text-muted" style={{ fontSize: '12px' }}>Sin gestiones registradas.</p>
      ) : (
        historial.map((h, i) => (
          <div key={i} className="card mb-2 p-2" style={{ fontSize: '12px' }}>
            <div className="d-flex justify-content-between">
              <strong>{ACCIONES.find(a => a.value === h.accion)?.label || h.accion}</strong>
              <span className="text-muted">{h.fecha_registro?.substring(0, 10)}</span>
            </div>
            {h.canal && <div className="text-muted">Canal: {h.canal}</div>}
            {h.comentario && <div>{h.comentario}</div>}
            {h.proxima_fecha && <div className="text-primary">Seguimiento: {h.proxima_fecha}</div>}
            <div className="text-muted">Por: {h.nombre_usuario} {h.apellido_usuario}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default FichaGestion;
